export function showLimitsEnabled(storageKey) {
    return localStorage.getItem(storageKey) !== "false";
}

export function buildShowLimitsToggle(id, storageKey, onChange) {
    const wrapper = document.createElement("div");
    wrapper.className = "form-check form-switch ms-2 mb-1";
    wrapper.style.whiteSpace = "nowrap";

    const input = document.createElement("input");
    input.className = "form-check-input";
    input.type = "checkbox";
    input.id = id + "_showLimits";
    input.setAttribute("role", "switch");
    input.checked = showLimitsEnabled(storageKey);

    const label = document.createElement("label");
    label.className = "form-check-label small";
    label.htmlFor = input.id;
    label.textContent = "Show limits";

    input.addEventListener("change", () => {
        localStorage.setItem(storageKey, input.checked ? "true" : "false");
        onChange(input.checked);
    });

    wrapper.appendChild(input);
    wrapper.appendChild(label);
    return wrapper;
}

// Move the card heading into a title-bar wrapper so visible controls (legend,
// switches) can sit beside it instead of inside the <h5>. The <h5> keeps its
// own accessible name as just the card title.
export function ensureTitleBar(titleEl) {
    if (!titleEl) return null;
    const parent = titleEl.parentElement;
    if (parent && parent.classList.contains("dashbox-titlebar")) {
        return parent;
    }
    const bar = document.createElement("div");
    bar.className = "dashbox-titlebar";
    if (parent) {
        parent.insertBefore(bar, titleEl);
    }
    bar.appendChild(titleEl);
    const heading = titleEl.textContent.trim();
    if (heading) {
        titleEl.setAttribute("aria-label", heading);
    }
    return bar;
}

// Place the "Show limits" switch at the right of the widget's title bar so it
// doesn't leave a standalone gap row above the chart.
export function attachShowLimitsToggle(base, id, storageKey, onChange) {
    const toggle = buildShowLimitsToggle(id, storageKey, onChange);
    const title = base.querySelector(".dashbox-title");
    if (title) {
        toggle.classList.remove("ms-2", "mb-1");
        toggle.classList.add("lqos-title-toggle");
        ensureTitleBar(title).appendChild(toggle);
    } else {
        base.appendChild(toggle);
    }
    return toggle;
}
